import { createContext, useContext } from 'react';
import { ICtSearchOptionsContext } from '@vivli/features/search/infrastructure/interface';

export const CtSearchOptionsContext = createContext<ICtSearchOptionsContext>(null);

export const useCtSearchOptionsContext = () => useContext(CtSearchOptionsContext);
